module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "myfade"
    }
  }, [(_vm.active) ? _c('div', {
    class: _vm.classes
  }, [_c('dn-spinner')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b91d80","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/loadings/Loading.vue
// module id = 333
// module chunks = 1